import { useRef } from 'react'
import { ColumnStore, createColumnsStore } from './ColumnsStore'

import { createContext } from 'react'
import { FilterIdentifier } from '../../models/saved_view'
import { useAuth } from 'context/authentication/useAuth'

export const ColumnStoreContext = createContext<ColumnStore | null>(null)

export function ColumnsStoreProvider({
  children,
  tableKey,
  defaultColumnVisibility,
  initialColumnOrder,
  preferredGroupOrder,
  savedPresetsIdentifier,
}: {
  children: React.ReactNode
  tableKey: string
  defaultColumnVisibility?: Record<string, boolean>
  initialColumnOrder?: string[]
  preferredGroupOrder?: string[]
  savedPresetsIdentifier?: FilterIdentifier
}) {
  const { user } = useAuth()
  const storeRef = useRef<ColumnStore | null>(null)
  if (!storeRef.current) {
    storeRef.current = createColumnsStore({
      tableKey,
      defaultColumnVisibility,
      initialColumnOrder,
      preferredGroupOrder,
      savedPresetsIdentifier,
      userId: user?.id,
    })
  }
  return (
    <ColumnStoreContext.Provider value={storeRef.current}>
      {children}
    </ColumnStoreContext.Provider>
  )
}
